import { CustomDomainStatus } from 'generated/graphql';

export type LandingDomainOwner = {
  customURL?: string | null;
  customDomains?: Array<{
    id: number;
    domain: string;
    status: CustomDomainStatus;
  }> | null;
};

export const resolveLandingBaseUrl = (owner: LandingDomainOwner | null) => {
  if (!owner) return null;

  const customDomain = owner.customDomains?.find(
    (domain) =>
      domain?.status === CustomDomainStatus.InfraRunning && domain.domain,
  );

  if (customDomain?.domain) {
    return `https://${customDomain.domain}`;
  }

  if (!owner.customURL) return null;

  return `${import.meta.env.VITE_LANDING_PAGE_URL}/${owner.customURL}`;
};

export const getOfferLandingPageUrl = (
  owner: LandingDomainOwner | null,
  offerId?: string,
) => {
  if (!owner || !offerId) return null;
  const baseUrl = resolveLandingBaseUrl(owner);
  if (!baseUrl) return null;
  const normalizedOfferId = `${offerId}`.trim();
  if (!normalizedOfferId) return null;
  return `${baseUrl}/offers/${encodeURIComponent(normalizedOfferId)}`;
};
